module.exports = __webpack_public_path__ + "img/category-favorite-hover.0acc3214.png";